/**
 * Area-spezifische API-Funktionen
 * Flächen-Daten und Shapefile-Upload
 */
import { api, getAuthHeaders, getBaseUrl } from "./client";

export const areasApi = {
  async getProjectArea(projectId: string): Promise<any> {
    return api.get(`/projects/${projectId}/area`);
  },

  async updateProjectArea(projectId: string, areaData: any): Promise<any> {
    return api.patch(`/projects/${projectId}/area`, areaData);
  },

  /**
   * Holt die verfügbaren Auswahlwerte für den Flächenakquise-Status
   */
  async getFlaechenakquiseStatusOptions(): Promise<{ options: string[] }> {
    return api.get("/areas/flaechenakquise-status-options");
  },

  /**
   * Shapefile-Upload für Flächen-Extraktion
   * Extrahiert Geometrie und Bundesland aus einer Shapefile-ZIP
   */
  async uploadShapefile(file: File): Promise<{
    geometrie?: any;
    flaeche?: Array<{ laengengrad: number; breitengrad: number }>; // Fallback für altes Backend
  }> {
    const formData = new FormData();
    formData.append("file", file);

    const headers = await getAuthHeaders();
    // Entferne Content-Type Header - Browser setzt automatisch den richtigen mit boundary
    delete headers["Content-Type"];

    const response = await fetch(`${getBaseUrl()}/areas/import-shapefile`, {
      method: "POST",
      headers: headers,
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.detail?.message ||
          errorData.detail ||
          `HTTP ${response.status}: ${response.statusText}`,
      );
    }

    return response.json();
  },
};
